import { render, staticRenderFns } from "./JqueryTable.vue?vue&type=template&id=3ff1c2ea&scoped=true&"
import script from "./JqueryTable.vue?vue&type=script&lang=js&"
export * from "./JqueryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff1c2ea",
  null
  
)

export default component.exports